import { render, staticRenderFns } from "./LgsOrderPurcharseDuplicate.vue?vue&type=template&id=01e9d626&"
import script from "./LgsOrderPurcharseDuplicate.vue?vue&type=script&lang=js&"
export * from "./LgsOrderPurcharseDuplicate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports